import * as ohm from "ohm-js";

let grammar = null;
let resulObject = [];

function getGrammar(dictionary) {
  let exp = Object.keys(dictionary)
    .map((key) =>
      dictionary[key].operation.map((o) => `${key}  ${o} Array`).join("|")
    )
    .join("|");
  const grammarText = `Search {
   Exp=  ${exp}
    
     ${Object.keys(dictionary)
       .map((key) => key + "=" + '"' + key + '"')
       .join("\n")}
    
    Exact="Exact"
    Like="Like"
    Between="Between"
    Must="Must"
    Can="Can"
    
    Array= Prhase ("," Prhase)*
    Prhase=word+
      word =( character|white_space)+
    character
       =  (letter | digit | "_" | "-" | "+" | "#" | "." | "/" | ":" )
    white_space= " " 
    }
    `;
  return ohm.grammar(grammarText);
}

function InitGrammar(dictionary) {
  grammar = getGrammar(dictionary);
}
function parse(text) {
  let actions = {
    character(letter) {
      return letter.sourceString.substring(letter.startIdx, letter.endIdx);
    },
    white_space(space) {
      return space.sourceString.substring(space.startIdx, space.endIdx);
    },
    word(singleWord) {
      let word = singleWord.children.map((c) => c.eval());

      return word.join("").trim();
    },
    Prhase(listOfWords) {
      let prhase = listOfWords.children.map((c) => c.eval());

      return prhase.join("");
    },
    Array(singleWord, comma, multipleWord) {
      let array = [singleWord.eval()];

      for (let i = 0; i < multipleWord.children.length; i++) {
        array.push(multipleWord.children[i].eval());
      }
      return array;
    },
    Exp(field, operation, list) {
      let result = list.eval();
      return {
        field: field?.source.sourceString.substring(
          field.source.startIdx,
          field.source.endIdx
        ),
        operation: operation?.source.sourceString.substring(
          operation.source.startIdx,
          operation.source.endIdx
        ),
        list: result
      };
    },

    _terminal(...args) {},
    // _
    _iter(...args) {},
    //  _list(...args) {},
    //  _default(...args) {},
    _nonterminal(...args) {}
  };

  let semantic = grammar.createSemantics().addOperation("eval", actions);
  let match = grammar.match(text);

  if (match.succeeded()) {
    var s = semantic(match);
    var r = s.eval();
    return { success: true, result: r };
  } else return { success: false, result: match.message };
}
export const smartSearch = { parse, InitGrammar };
